module.exports = __webpack_public_path__ + "static/ananda-mohan-17ab98762a4e393113be767d392a1858.jpg";